export enum jobActionButtonKeys {
  EXPRESS_INTEREST = "express-interest",
  QUICK_APPLY = "quick-apply",
  EXTERNAL_APPLICATION = "external-application",
}

export const MISSING_SCHOOL_NCES_ID = "N/A";
